var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRecalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 10.8542C18 9.26295 17.3679 7.73683 16.2426 6.61161C15.1174 5.48639 13.5913 4.85425 12 4.85425C10.4087 4.85425 8.88258 5.48639 7.75736 6.61161C6.63214 7.73683 6 9.26295 6 10.8542V18.8542H18V10.8542ZM20 19.5212L20.4 20.0542C20.4557 20.1285 20.4896 20.2169 20.498 20.3093C20.5063 20.4018 20.4887 20.4948 20.4472 20.5779C20.4057 20.6609 20.3419 20.7308 20.2629 20.7796C20.1839 20.8284 20.0929 20.8542 20 20.8542H4C3.90714 20.8542 3.81612 20.8284 3.73713 20.7796C3.65815 20.7308 3.59431 20.6609 3.55279 20.5779C3.51126 20.4948 3.49368 20.4018 3.50202 20.3093C3.51036 20.2169 3.54429 20.1285 3.6 20.0542L4 19.5212V10.8542C4 8.73252 4.84286 6.69768 6.34315 5.19739C7.84344 3.6971 9.87827 2.85425 12 2.85425C14.1217 2.85425 16.1566 3.6971 17.6569 5.19739C19.1571 6.69768 20 8.73252 20 10.8542V19.5212ZM9.5 21.8542H14.5C14.5 22.5173 14.2366 23.1532 13.7678 23.622C13.2989 24.0909 12.663 24.3542 12 24.3542C11.337 24.3542 10.7011 24.0909 10.2322 23.622C9.76339 23.1532 9.5 22.5173 9.5 21.8542Z",
    fill: "#C6D5FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecalls);
export default __webpack_public_path__ + "static/media/icon-recalls.1e8399d4c2b0ecfd85514cf650cd54d8.svg";
export { ForwardRef as ReactComponent };